import { HarmonyChat } from '@rapidsos/harmony-chat';
import '@rapidsos/harmony-chat/dist/harmony-chat.css';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { useTheme } from 'styled-components';
import { getAPIHost } from '@rsos/base-utils/metaTags';
import { hideHarmonyChat } from '@rsos/reduxDataStore/src/features/harmonyChat/harmonyChatSlice';
import { refreshAccessToken } from './authHelpers';
import { harmonyChatTheme } from './harmonyChatTheme';

// override the default h2 style with important to ensure it is applied
const ChatContainer = styled.div`
  height: 100%;
  width: 420px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    height: calc(100vh - 155px);
  }

  & h2 {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
`;

export const HarmonyChatWrapper = () => {
  const dispatch = useDispatch();
  // Get refresh token from Redux store
  const refreshToken = useSelector(
    state => state.sinatra?.auth?.tokens?.refresh_token,
  );
  const theme = useTheme();

  const handleClose = useCallback(() => {
    dispatch(hideHarmonyChat());
  }, [dispatch]);

  const myAuthHandler = useCallback(async () => {
    try {
      if (!refreshToken) {
        return 'token-error';
      }

      const accessToken = await refreshAccessToken(refreshToken);
      return accessToken;
    } catch (error) {
      return 'token-error';
    }
  }, [refreshToken]);

  // memoize the API host
  const apiHost = useMemo(() => getAPIHost(), []);

  return (
    <ChatContainer className="bg-background">
      <HarmonyChat
        suggestions={[
          'How do I submit my agency’s Jurisdictional Boundary File?',
          "What's the weather today in San Diego?",
          'How do I add users to RapidSOS Unite?',
        ]}
        isDarkMode={theme.colors.name.toLowerCase() === 'dark'}
        baseApiHost={apiHost}
        agentUriPath="/v1/harmony-chat-proxy/chat"
        authHandler={myAuthHandler}
        productName="RSP"
        theme={harmonyChatTheme}
        onClose={handleClose}
        disclaimer="Ask Harmony is in beta and can make mistakes. RapidSOS cannot guarantee accuracy."
      />
    </ChatContainer>
  );
};
